import { createFileRoute, redirect } from '@tanstack/react-router';

/** The Company group opens on its first topic, General; the address was the whole Company page. */
export const Route = createFileRoute('/t/$tenant/settings/company/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/t/$tenant/settings/company/general',
      params: { tenant: params.tenant },
      replace: true,
    });
  },
});
